import { NavLink } from "react-router";
import DOMPurify from "dompurify";

import { Thread } from "models/inbox/inbox";
import { Icon } from "components/icon/Icon";
import Time from "common/Time";

import "./InboxPreviewItem.scss";

type Props = {
  link: string;
  thread: Thread;
};

export default function InboxPreviewItem({ link, thread }: Props) {
  const appendedIcon = thread.gotAttachment && (
    <Icon id={thread.threadId} name="paperclip" size="lg" />
  );

  const createSubscribers = () => {
    if (thread.subscribers.length < 2) {
      return;
    }
    let subscribers = " till ";
    thread.subscribers.forEach((subscriber) => {
      if (subscriber.id !== thread.lastMessage.from) {
        subscribers += subscriber.givenName + " " + subscriber.surName + ", ";
      }
    });
    return subscribers.slice(0, subscribers.length - 2);
  };

  return (
    <NavLink title="Läs meddelandet" to={link} className="previewItemWrapper">
      <div className="previewMessage">
        <div className="messageWrapper">
          <h5>{thread.title}</h5>
          <div className="messageRecipients">
            <strong className="sender">
              {thread.lastMessage.formatedFrom}
            </strong>
            {createSubscribers()}
          </div>
          <div
            className="messageBody"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(thread.lastMessage.body)
            }}
          />
        </div>
        <div className="metaWrapper">
          {appendedIcon}
          <time>{Time.formatShort(thread.lastMessage.createdAt)}</time>
        </div>
      </div>
    </NavLink>
  );
}
